import { render, staticRenderFns } from "./fragment-checkbox.vue?vue&type=template&id=1b86d451&scoped=true&"
import script from "./fragment-checkbox.vue?vue&type=script&lang=js&"
export * from "./fragment-checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b86d451",
  null
  
)

export default component.exports